// Where a stored agreement document came from.
export var BusinessAgreementSource;
(function (BusinessAgreementSource) {
    // The standard MSA, signed in the portal.
    BusinessAgreementSource["DocuSign"] = "DOCUSIGN";
    // A signed negotiated agreement, uploaded by the business.
    BusinessAgreementSource["BusinessUpload"] = "BUSINESS_UPLOAD";
    // Uploaded by an admin.
    BusinessAgreementSource["AdminUpload"] = "ADMIN_UPLOAD";
    // Moved from a live access request made before agreements lived on the
    // business.
    BusinessAgreementSource["Legacy"] = "LEGACY";
})(BusinessAgreementSource || (BusinessAgreementSource = {}));
//# sourceMappingURL=BusinessAgreementSource.js.map